import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
	name: "pidNoDash",
})
export class PidNoDashPipe implements PipeTransform {
	transform(value: any, _args?: any): any {
		return value && value.replace ? value.replace(/-/g, "") : value;
	}
}
